import React, { useEffect, useRef, useState } from "react";
import { animate, hover } from "motion";
import { Sortable, Plugins } from "@shopify/draggable";
import "../Vender/css/Hotels.css";
import { GripVertical, PhoneCall } from "lucide-react";
import { Link } from "react-router-dom";
import { getAllHotels } from "../api/hotels.api";

// const people = [
//   {
//     name: "Lukas Meier",
//     status: "Online",
//     rating: 4.5,
//     followers: "3.1 K",
//     description:
//       "Digital product designer crafting intuitive, scalable user journeys",
//     image: "/assets/images/dubai-bg.jpeg",
//   },
//   {
//     name: "Max Steiner",
//     status: "Online",
//     rating: 4.0,
//     followers: "2.4 K",
//     description:
//       "Digital designer turning complex workflows into seamless journeys",
//     image: "/assets/images/gangtok-bg.jpeg",
//   },
//   {
//     name: "Ueli Huber",
//     status: "Offline",
//     rating: 5.0,
//     followers: "1.7 K",
//     description:
//       "UX strategist designing frictionless, data-driven digital experiences",
//     image: "/assets/images/jaipur-bg.jpeg",
//   },
// ];

const Card = ({ hotel, index }) => (
  <div className="card-wrap">
    <div
      className={`card ${hotel.hotel_name === "Coorg Cliffs Resort" ? "coorg-cliffs-resort" : ""}`}
    >
      <div className="card-filter"></div>
      <img src={`${hotel.image}`} alt="bg" className="card-bg" />

      {/* <div className="card-status">
        <div className={`card-status-dot online`}></div>
        <div className="card-status-text">available</div>
      </div> */}

      <div className="card-handle grab">
        <div
          className="card-handle-tip"
          aria-label="Drag"
          data-microtip-position="left"
          role="tooltip"
        >
          <span
            className="iconify handle"
            data-icon="ic:outline-drag-indicator"
          >
            <GripVertical />
          </span>
        </div>
      </div>

      <div className="card-content">
        <div className="card-name-wrap">
          <div className="card-name">{hotel.hotel_name}</div>
          <div
            className="card-verfied"
            aria-label="Verified"
            data-microtip-position="right"
            role="tooltip"
          >
            <span
              className="card-verification iconify"
              data-icon="si:verified-fill"
            ></span>
          </div>
        </div>

        <div className="card-description">{hotel.introduction}</div>
      </div>
      <div className="card-fade"></div>
    </div>
  </div>
);

const ProfileCards = () => {
  const [hotels, setHotels] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const hotels = await getAllHotels();
      setHotels(hotels || []);
      console.log(hotels);
    };
    fetchData();
  }, []);

  const cardsRef = useRef(null);

  useEffect(() => {
    const made = document.querySelector(".made");
    if (made) {
      animate(made, { scale: [0.75, 1], opacity: [0, 0.75] }, { delay: 0.25 });
      hover(made, () => {
        animate(
          made,
          { scale: 1.02, opacity: 1 },
          { type: "spring", stiffness: 200 },
        );
        return () =>
          animate(made, { scale: 1, opacity: 0.75 }, { type: "spring" });
      });
    }

    if (cardsRef.current) {
      const sortable = new Sortable(cardsRef.current, {
        draggable: ".card-wrap",
        handle: ".card-handle",
        plugins: [Plugins.SortAnimation],
        mirror: {
          constrainDimensions: true,
        },
      });

      return () => sortable.destroy();
    }
  }, []);

  return (
    <div id="hotels">
      <div className="hotel-banner py-5">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item text-light">
              <Link to="/" className="text-light">
                Home
              </Link>
            </li>
            <li
              className="breadcrumb-item active text-light"
              aria-current="page"
            >
              Hotels
            </li>
          </ol>
        </nav>
      </div>
      <section ref={cardsRef} className="hotel-grid py-5">
        {hotels.map((hotel, index) => (
          <Card key={index} hotel={hotel} index={index} />
        ))}
      </section>
    </div>
  );
};

export default ProfileCards;
